import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';
import { Link } from 'react-router-dom';

export function DidYouKnow({ className, ...rest }: CKContainerProps) {
  return (
    <div {...rest} className={classnames(className, 'text-center space-y-4')}>
      <h2 className="font-medium">Did you know?</h2>
      <p className="text-gray-500">
        You can <Link to="/tam-calculator">define Target Markets</Link> and use
        those for prospecting into, focusing your attention and search on the
        people at companies in your entire addressable market, or in specific
        markets you care about most.
      </p>
      <p>
        <a href="/">Learn more</a>
      </p>
    </div>
  );
}
